<template>
  <el-select 
    v-model="selectValue"
    :placeholder="placeholder"
    size="small"
    :disabled="disabled"
    :filterable="filterable"
    :default-first-option="defaultFirstOption"
    @change="handleChange"
  >
    <el-option
      v-for="(option, index) in list"
      :key="index"
      :label="option[labelKey]"
      :value="String(option[valueKey])"
    />
  </el-select>
</template>

<script>
export default {
  name: 'VSelect',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    list: {
      type: Array,
      default: (() => [])
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: 'Please Select'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: true
    },
    defaultFirstOption: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectValue: String(this.value)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if(val !== this.selectValue) {
          this.handleValue(val)
        }
      }
    },
    selectValue(val) {
      this.$emit('input', val)
    }
  },
  methods: {
    handleChange(v) {
      console.log(v)
    },
    handleValue(value) {
      let val = value
      val = String(val)
      let result = this.list.filter(item => String(item[this.valueKey]) === val)
      this.selectValue = result.length > 0 ? val: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>